import React, { useEffect } from 'react';
import './youtube-player.css';

export const YouTubePlayer = ({ videoId }) => {
  useEffect(() => {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    let player;

    window.onYouTubeIframeAPIReady = () => {
      player = new window.YT.Player('mainVideo', {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          controls: 0,
          showinfo: 0,
          mute: 1,
          modestbranding: 1,
          wmode: 'transparent'
        },
        events: {
          'onStateChange': onPlayerStateChange
        }
      });
    };

    const onPlayerStateChange = (event) => {
      if (event.data === window.YT.PlayerState.ENDED) {
        player.seekTo(0);
      }
    };

    return () => {
      window.onYouTubeIframeAPIReady = null;
      if (player) {
        player.destroy();
      }
    };
  }, [videoId]);

  return <div id="mainVideo" className='yt-wrap'></div>;
};